import React from 'react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import BackIcon from '../assets/images/Button_Back.png'; // Replace with your back icon path
export const BackButton = () => {
  const navigate = useNavigate ();

  const handleBack = () => {
    navigate (-1);
  };

  return (
    <Container onClick={handleBack}>
      <img src={BackIcon} alt="" width={'100%'} height={'100%'} />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
    top: calc(10 / 2160 * 100vh);
    left: calc(100/ 4096 * 100vw);
    width: calc(410 / 4096 * 100vw);
    height: calc(174 / 2160 * 100vh);
  `;
